/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Tournament_Rules_DescriptionInputs */



/**
* | output |
* | --- |
* | "Official VEKN tournament rules and procedures." |
*
* @param {Help_Tournament_Rules_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_tournament_rules_description = /** @type {((inputs?: Help_Tournament_Rules_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Tournament_Rules_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles et procédures officielles de tournoi de la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reglas y procedimientos oficiales de torneo de VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regras e procedimentos oficiais de torneio da VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regole e procedure ufficiali dei tornei VEKN.")
	return /** @type {LocalizedString} */ ("Official VEKN tournament rules and procedures.")
});